"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TgglResponse = void 0;
var TgglResponse = /** @class */ (function () {
    function TgglResponse(flags, options) {
        if (flags === void 0) { flags = {}; }
        if (options === void 0) { options = {}; }
        var _a;
        this.flags = flags;
        this.reporting = (_a = options.reporting) !== null && _a !== void 0 ? _a : null;
    }
    TgglResponse.prototype.disableReporting = function () {
        var _a;
        (_a = this.reporting) === null || _a === void 0 ? void 0 : _a.disable();
        this.reporting = null;
    };
    TgglResponse.prototype.detachReporting = function () {
        var reporting = this.reporting;
        this.reporting = null;
        return reporting;
    };
    TgglResponse.prototype.get = function (slug, defaultValue) {
        var _a;
        var value = this.flags[slug] === undefined
            ? defaultValue
            : this.flags[slug];
        (_a = this.reporting) === null || _a === void 0 ? void 0 : _a.reportFlag(String(slug), {
            default: defaultValue,
            value: value,
        });
        // @ts-ignore
        return value;
    };
    TgglResponse.prototype.getActiveFlags = function () {
        return this.flags;
    };
    return TgglResponse;
}());
exports.TgglResponse = TgglResponse;
